import { useThirdPartyState } from '../../components/ThirdParty';
import { type InviteThirdPartyTeamsState } from './useInviteThirdPartyTeamsEligibility';

export const useInviteThirdPartyTeams = (): InviteThirdPartyTeamsState =>
	useThirdPartyState().inviteThirdPartyTeams;
